export default __webpack_public_path__ + "static/media/payment.4c3542d9.png";